import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/layout/ScrollToTop";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import AboutUs from "@/pages/AboutUs";
import GlobalStaffing from "@/pages/GlobalStaffing";
import ITStaffing from "@/pages/ITStaffing";
import VendorPartnership from "@/pages/VendorPartnership";
import CandidateProfileMarketing from "@/pages/CandidateProfileMarketing";
import OurProcess from "@/pages/OurProcess";
import Contact from "@/pages/Contact";
import HireTalent from "@/pages/HireTalent";
import BecomeVendorPartner from "@/pages/BecomeVendorPartner";
import JoinTalentPool from "@/pages/JoinTalentPool";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1 pt-16 md:pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/global-staffing" element={<GlobalStaffing />} />
            <Route path="/it-staffing" element={<ITStaffing />} />
            <Route path="/vendor-partnership" element={<VendorPartnership />} />
            <Route path="/candidate-profile-marketing" element={<CandidateProfileMarketing />} />
            <Route path="/our-process" element={<OurProcess />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/hire-talent" element={<HireTalent />} />
            <Route path="/become-vendor-partner" element={<BecomeVendorPartner />} />
            <Route path="/join-talent-pool" element={<JoinTalentPool />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
